import React from 'react';
import { connect } from 'react-redux';
import './message.css';

const icon = {
  success: {
    color: 'green',
    symbol: '\u2714',
  },
  error: {
    color: 'red',
    symbol: 'x',
  },
  warning: {
    color: 'orange',
    symbol: '!',
  },
  info: {
    color: '#40a9ff',
    symbol: 'i',
  },
};

function Message({ showing, data }) {
  if (!showing) return null;
  return (
    <div className="Message">
      <span>
        <div className="Message__content">
          <i
            style={{
              color: icon[data.category].color,
              fontWeight: 'bold',
            }}
          >
            {icon[data.category].symbol}
          </i>
          <span>{data.content}</span>
        </div>
      </span>
    </div>
  );
}

const mapStateToProps = ({ messageReducer }) => ({
  showing: messageReducer?.showing || false,
  data: messageReducer?.data || {},
});

export default connect(mapStateToProps)(Message);
